import React, { Component } from 'react';
import '../../styles/components/filter.scss';
import { Loader2 } from 'lucide-react';

export default class FilterSection extends Component {
  render() {
    const { children, loading, onSearch, onClear } = this.props;

    return (
      <div className="filter-section">
        <div className="filters">{children}</div>
        <div className="filter-actions">
          <button className="clear-btn" onClick={onClear}>
            Clear
          </button>
          <button className="search-btn" disabled={loading} onClick={onSearch}>
            {loading ? (
              <span
                style={{
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <Loader2 className="animate-spin" size={16} /> Loading
              </span>
            ) : (
              'Search'
            )}
          </button>
        </div>
      </div>
    );
  }
}
